import { Col, Row } from "reactstrap";

//DataTable
import ContactTable from "../../DataTables/CompanyContact/CompanyContactTable";

//Card
import OrgStrucureCard from "./OrganizationalStructure";
import OpStructureCard from "./OperationalStructure";
import JobsCard from "./JobsCard";

//Types
import { ViewCompanyProfile } from "../../../Types/CompanyProfile/CompanyProfile";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
};

const CompanyDetails = ({ companyInfo }: CompanyDataProps) => {
  return (
    <Row>
      <Col sm="8">
        <Col sm="12">
          <JobsCard companyInfo={companyInfo} />
        </Col>
        <Col sm="12" style={{ marginBottom: "50px" }}>
          <OrgStrucureCard companyInfo={companyInfo} />
        </Col>
        <Col sm="12" style={{ marginBottom: "50px" }}>
          <OpStructureCard companyInfo={companyInfo} />
        </Col>
      </Col>
      <Col sm="4" style={{ marginBottom: "50px" }}>
        <Col sm="12" style={{ marginBottom: "50px" }}>
          <ContactTable code={companyInfo?.code} />
        </Col>
      </Col>
    </Row>
  );
};

export default CompanyDetails;
